module.exports = __webpack_public_path__ + "audio/notification-sonore.b93d4006.mp3";